<template>
   <el-container>
        <el-aside :width="isCollapse? '0':'300px'" :class="isCollapse? 'nav n-close':'nav n-open'" >
            <Sidebar/>
        </el-aside>
        <el-container>
            <el-header>
                <Header/>
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
            <el-footer>
                {{ $t('Version') }}
            </el-footer>
            <span ref="webModeCheck" class="webMode"></span>
        </el-container>
    </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from './component/Header'
import Sidebar from './component/Sidebar'
export default {
	name: 'Layout',
	components: { Header,Sidebar },
	computed: {
		...mapGetters([
			'sidebar'
		]),
		isCollapse() {
			return !this.sidebar.open
		}
	},
	mounted() {
		if(this.getWebModeCheckWidth()<=0) {
			//小網-預設選單關閉
			this.sidebar.open=!this.sidebar.open
		}
	},
	methods: {
		getWebModeCheckWidth() {
			return this.$refs.webModeCheck.offsetWidth;
		},
	},
}

</script>
